import type { Edge, Node } from "@xyflow/react";
import { type ExplodeNodeData, NodeKind } from "../../types";

export const NODE_WIDTH = 200;
export const COLUMN_GAP = 72;
export const ROW_GAP = 132;
export const ROOT_Y = 0;
export const GRID_TOP = 130;
export const MAX_COLUMNS = 8;
export const TARGET_ASPECT = 3.6;
export const OVERLAY_Z = 20;

export const ZONE_ROWS = 2;
export const ZONE_WIDTH = NODE_WIDTH + 120;
export const ZONE_LEFT_OFFSET = NODE_WIDTH + 160;
export const ZONE_TOP_OFFSET = -120;
export const TITLE_SLOT_HEIGHT = 96;
export const ZONE_ROW_GAP = 70;

export const GHOST_COUNT = 4;
export const GHOST_ZONE_SLOTS = 2;
export const OVERLAY_PAGE_SIZE = 25;
export const FIELD_FOCUS_TOP_VALUES = 8;
export const STAGE_Z = 40;

export const graphNode = (
    id: string,
    x: number,
    y: number,
    data: ExplodeNodeData,
    zIndex = 0,
): Node<ExplodeNodeData> => ({ id, type: NodeKind.BUCKET, position: { x, y }, data, zIndex });

export const titleEdge = (source: string, target: string, id: string): Edge => ({
    id,
    source,
    target,
    type: "default",
    zIndex: OVERLAY_Z - 1,
    style: { stroke: "#9775fa", strokeWidth: 1.6 },
});

export const valueEdge = (source: string, target: string, id: string): Edge => ({
    id,
    source,
    target,
    type: "default",
    zIndex: OVERLAY_Z - 1,
    style: { stroke: "#d0bfff", strokeWidth: 1 },
});

export const columnsForAspect = (count: number): number => {
    const cellAspect = ROW_GAP / (NODE_WIDTH + COLUMN_GAP);
    const ideal = Math.round(Math.sqrt(count * TARGET_ASPECT * cellAspect));
    return Math.min(Math.max(ideal, 1), MAX_COLUMNS);
};

export const rowTops = (centerY: number): [number, number] => {
    const rowZeroY = centerY + ZONE_TOP_OFFSET;
    return [rowZeroY, rowZeroY + TITLE_SLOT_HEIGHT + ZONE_ROW_GAP];
};
